<template>
  <div>
    <div class="display-1 font-weight-normal mb-6 text-center">
      Configure os campos participantes de cada rodada
    </div>

    <v-expansion-panels v-model="panels" accordion class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header class="font-weight-light">
          Editar Prioridade
          <span v-if="prioridades.length" class="caption grey--text ml-2">
            ({{ prioridades.length }} campo{{ prioridades.length === 1 ? '' : 's' }})
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row justify="center" align="center" no-gutters class="mb-2 text-center" style="font-size: 14px">
            <v-col sm="4" cols="12">
              <p class="mb-0" :style="{ color: tipoOrdenacaoEfetivo === 'RELEVANCIA' ? 'rgba(0, 0, 0, 0.3)' : '#E5502C' }">
                Ordenação Padrão
              </p>
            </v-col>
            <v-col cols="auto" class="px-4">
              <v-tooltip bottom :disabled="!blindados.length">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-switch
                      :input-value="tipoOrdenacaoEfetivo === 'RELEVANCIA'"
                      class="mt-0 pt-0 switch-tipo-ordenacao"
                      :disabled="loading || blindados.length > 0"
                      hide-details
                      @change="alterarTipoOrdenacao"
                    />
                  </div>
                </template>
                <span>Com campo blindado a ordenação é sempre por Relevância</span>
              </v-tooltip>
            </v-col>
            <v-col sm="4" cols="12">
              <p class="mb-0" :style="{ color: tipoOrdenacaoEfetivo === 'RELEVANCIA' ? '#E5502C' : 'rgba(0, 0, 0, 0.3)' }">
                Ordenação por Relevância
              </p>
            </v-col>
          </v-row>
          <p class="caption grey--text mb-3">
            A ordem e a seleção abaixo definem o universo das rodadas. Alterar a prioridade regenera o conjunto.
            <br />
            Clique no campo para alternar: 1º clique seleciona, 2º blinda e 3º desmarca. Campos blindados ficam fixos em todas as
            rodadas e no topo da prioridade.
            <br />
            Arraste os campos para alterar a ordem de prioridade.
          </p>
          <div v-if="atributosBlindados.length" class="campos-prioridade-lista">
            <div v-for="atributo in atributosBlindados" :key="'prio-' + atributo.id" class="campo-prioridade-item py-1">
              <v-icon small class="mr-1 grey--text text--lighten-1">mdi-pin</v-icon>
              <div
                class="campo-prioridade"
                :class="{ 'campo-prioridade--travado': loading }"
                role="checkbox"
                tabindex="0"
                aria-checked="true"
                @click="ciclarEstadoCampo(atributo)"
                @keydown.space.prevent="ciclarEstadoCampo(atributo)"
                @keydown.enter.prevent="ciclarEstadoCampo(atributo)"
              >
                <v-icon small :color="corEstado(atributo.id)" class="mr-2">
                  {{ iconeEstado(atributo.id) }}
                </v-icon>
                <span>{{ atributo.nome }}</span>
              </div>
            </div>
          </div>
          <draggable v-model="atributosLivres" class="campos-prioridade-lista" v-bind="dragOptions" @end="onPrioridadeChange">
            <div v-for="atributo in atributosLivres" :key="'prio-' + atributo.id" class="campo-prioridade-item py-1">
              <v-icon small class="mr-1 grey--text campo-prioridade-drag">mdi-drag</v-icon>
              <div
                class="campo-prioridade"
                :class="{ 'campo-prioridade--travado': loading }"
                role="checkbox"
                tabindex="0"
                :aria-checked="estadoPrioridade(atributo.id) === 'NAO_SELECIONADO' ? 'false' : 'true'"
                @click="ciclarEstadoCampo(atributo)"
                @keydown.space.prevent="ciclarEstadoCampo(atributo)"
                @keydown.enter.prevent="ciclarEstadoCampo(atributo)"
              >
                <v-icon small :color="corEstado(atributo.id)" class="mr-2">
                  {{ iconeEstado(atributo.id) }}
                </v-icon>
                <span>{{ atributo.nome }}</span>
              </div>
            </div>
          </draggable>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

    <draggable
      v-if="rodadas.length"
      v-model="rodadas"
      class="rodadas-lista"
      handle=".rodada-drag-handle"
      v-bind="dragOptions"
      @end="onMover"
    >
      <div v-for="(rodada, idx) in rodadas" :key="rodada.chave" class="rodada-card mb-4">
        <div class="rodada-card__header d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon class="rodada-drag-handle grey--text mr-2">mdi-drag-vertical</v-icon>
            <div>
              <strong>{{ rotuloRodada(idx) }} rodada</strong>
              <span v-if="rodada.peso != null" class="caption grey--text ml-2">peso {{ rodada.peso }}</span>
              <span v-if="rodada.origem === 'MANUAL' || rodada.idTemporario" class="caption orange--text ml-2">
                manual
              </span>
            </div>
          </div>
          <div class="rodada-card__actions d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="success"
                  small
                  :disabled="loading"
                  v-bind="attrs"
                  v-on="on"
                  @click="adicionarRodadaFinal(rodada)"
                >
                  <v-icon small>mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Adicionar nova rodadas</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="success"
                  small
                  :disabled="loading"
                  v-bind="attrs"
                  v-on="on"
                  @click="duplicarRodada(idx)"
                >
                  <v-icon small>mdi-plus-box-multiple</v-icon>
                </v-btn>
              </template>
              <span>Duplica rodada</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="error"
                  small
                  :disabled="loading || totalRodadas <= 1"
                  v-bind="attrs"
                  v-on="on"
                  @click="removerRodada(idx)"
                >
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover rodada</span>
            </v-tooltip>
          </div>
        </div>

        <v-row dense class="rodada-card__campos">
          <v-col
            v-for="atributo in atributosPrioridade"
            :key="atributo.id + '-' + rodada.chave"
            cols="12"
            sm="6"
            md="4"
            class="py-1"
          >
            <div class="atributo-item">
              <conciliacoes-check-box
                :label="atributo.nome"
                :value="atributo.id"
                :arrayValues.sync="rodada.campos"
                :readonly="isBlindado(atributo.id) || loading"
                @change="onCamposChange(rodada)"
                @click="
                  isBlindado(atributo.id)
                    ? $toast.warning(`O campo <b>${atributo.nome}</b> é blindado e deve estar em todas as rodadas.`, '', {
                        position: 'topRight',
                        timeout: 3000
                      })
                    : null
                "
              />
              <v-icon v-if="isBlindado(atributo.id)" x-small class="ml-1 mt-1" color="primary">mdi-lock</v-icon>
            </div>
          </v-col>
        </v-row>

        <div
          v-if="!(rodada.campos && rodada.campos.length)"
          class="error--text theme--light v-messages v-messages__message mt-1"
        >
          Selecione pelo menos 1 atributo
        </div>
      </div>
    </draggable>

    <div v-else-if="loading" class="caption grey--text text-center py-2">
      Gerando o conjunto de rodadas…
    </div>
    <div v-else class="caption grey--text text-center py-6">
      Nenhuma rodada disponível. Avance até esta aba após mapear Partida e Referência.
    </div>

    <v-row v-if="rodadas.length || pageIndex > 0" align="center" class="mt-2" no-gutters>
      <v-col cols="12" sm="6" class="caption grey--text text--darken-1">
        {{ textoPaginacao }}
      </v-col>
      <v-col cols="12" sm="6" class="d-flex justify-end align-center">
        <span class="caption mr-2">Itens por página: {{ porPagina }}</span>
        <v-btn icon :disabled="!hasPrev || loading" @click="$emit('pagina-anterior')">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon :disabled="!hasMore || loading" @click="$emit('pagina-proxima')">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { RODADAS_POR_PAGINA, RODADAS_BUFFER_INICIAL } from '@/mixins/conciliacoesV3/rodadasLoteMixins';

  export default {
    name: 'AbaRodadas',
    components: {
      ConciliacoesCheckBox: () => import('@/components/conciliacoes/ConciliacoesCheckBox.vue'),
      draggable: () => import('vuedraggable')
    },
    props: {
      value: { type: Array, default: () => [] },
      atributos: { type: Array, default: () => [] },
      loading: { type: Boolean, default: false },
      hasMore: { type: Boolean, default: false },
      hasPrev: { type: Boolean, default: false },
      pageIndex: { type: Number, default: 0 },
      total: { type: Number, default: null },
      camposConfig: { type: Array, default: () => [] },
      estadoPorCampo: { type: Object, default: () => ({}) },
      tipoOrdenacaoConfig: { type: String, default: null }
    },
    data: () => ({
      rodadas: [],
      prioridades: [],
      blindados: [],
      ordemCampos: [],
      tipoOrdenacao: 'PADRAO',
      panels: 0,
      skipPrioridadeEmit: false,
      prioridadeDebounce: null,
      chaveConfigBase: null,
      defaultPrioridades: 6,
      porPagina: RODADAS_POR_PAGINA
    }),
    computed: {
      totalRodadas() {
        return this.total != null ? Number(this.total) : this.rodadas.length;
      },
      dragOptions() {
        return {
          animation: 300,
          ghostClass: 'ghost',
          disabled: this.loading
        };
      },
      tipoOrdenacaoEfetivo() {
        return this.blindados.length ? 'RELEVANCIA' : this.tipoOrdenacao;
      },
      atributosPorId() {
        const byId = {};
        (this.atributos || []).forEach((a) => {
          byId[String(a.id)] = a;
        });
        return byId;
      },
      atributosBlindados() {
        return this.ordemCampos
          .filter((id) => this.isBlindado(id) && this.prioridades.includes(id))
          .map((id) => this.atributosPorId[id])
          .filter(Boolean);
      },
      atributosLivres: {
        get() {
          return this.ordemCampos
            .filter((id) => !this.atributosBlindados.some((a) => String(a.id) === id))
            .map((id) => this.atributosPorId[id])
            .filter(Boolean);
        },
        set(lista) {
          this.ordemCampos = [...this.atributosBlindados, ...lista].map((a) => String(a.id));
          this.ordenarPrioridades();
        }
      },
      atributosPrioridade() {
        const byId = {};
        (this.atributos || []).forEach((a) => {
          byId[String(a.id)] = a;
        });
        const ids = this.prioridades.length ? this.prioridades : this.camposConfig;
        return ids.map((id) => byId[String(id)]).filter(Boolean);
      },
      textoPaginacao() {
        const qtd = this.rodadas.length;
        if (!qtd) {
          return this.total != null ? `Exibindo 0 de ${this.total} rodadas` : 'Exibindo 0';
        }
        const inicio = this.pageIndex * RODADAS_POR_PAGINA + 1;
        const fim = inicio + qtd - 1;
        let total = this.total != null ? Number(this.total) : fim;
        if (fim > total) total = fim;
        return `Exibindo ${inicio}–${fim} de ${total} rodadas`;
      },
      idCampoTuc() {
        const tuc = (this.atributos || []).find((a) => String(a.nome || '').toUpperCase() === 'TUC');
        return tuc ? String(tuc.id) : null;
      }
    },
    watch: {
      value: {
        immediate: true,
        deep: true,
        handler(cards) {
          this.rodadas = (cards || []).map((c) => ({ ...c, campos: [...(c.campos || [])] }));
        }
      },
      camposConfig: {
        immediate: true,
        handler(ids) {
          if (ids && ids.length) {
            this.skipPrioridadeEmit = true;
            this.prioridades = ids.map(String);
            this.aplicarBlindadosDaConfig();
            this.sincronizarOrdemCampos();
            this.$nextTick(() => {
              this.skipPrioridadeEmit = false;
            });
            this.registrarConfigBase();
            return;
          }
          this.inicializarPrioridadesPadrao();
        }
      },
      estadoPorCampo: {
        immediate: true,
        handler() {
          if (this.camposConfig && this.camposConfig.length) {
            this.aplicarBlindadosDaConfig();
            this.registrarConfigBase();
          }
        }
      },
      atributos: {
        immediate: true,
        handler() {
          this.sincronizarOrdemCampos();
          if (!this.prioridades.length) {
            this.inicializarPrioridadesPadrao();
          }
        }
      },
      tipoOrdenacaoConfig: {
        immediate: true,
        handler(tipo) {
          if (tipo === 'PADRAO' || tipo === 'RELEVANCIA') this.tipoOrdenacao = tipo;
          this.registrarConfigBase();
        }
      }
    },
    beforeDestroy() {
      if (this.prioridadeDebounce) clearTimeout(this.prioridadeDebounce);
    },
    methods: {
      aplicarBlindadosDaConfig() {
        const estado = this.estadoPorCampo || {};
        this.blindados = Object.keys(estado)
          .filter((id) => estado[id] === 'BLINDADO')
          .map(String);
      },
      idsBlindados() {
        return this.prioridades.map(String).filter((id) => this.isBlindado(id));
      },
      garantirBlindados(campos) {
        const next = [...(campos || [])].map(String);
        const faltantes = this.idsBlindados().filter((id) => !next.includes(id));
        return [...faltantes, ...next];
      },
      inicializarPrioridadesPadrao() {
        const attrs = this.atributos || [];
        if (!attrs.length) {
          this.prioridades = [];
          return;
        }
        this.skipPrioridadeEmit = true;
        const ids = attrs.slice(0, this.defaultPrioridades).map((a) => String(a.id));
        if (this.idCampoTuc && !ids.includes(this.idCampoTuc)) {
          ids[ids.length - 1] = this.idCampoTuc;
        }
        this.prioridades = ids;
        this.blindados = this.idCampoTuc ? [this.idCampoTuc] : [];
        this.sincronizarOrdemCampos();
        this.ordenarPrioridades();
        this.$nextTick(() => {
          this.skipPrioridadeEmit = false;
        });
      },
      sincronizarOrdemCampos() {
        const idsMapeados = (this.atributos || []).map((a) => String(a.id));
        const mapeados = new Set(idsMapeados);
        const config = (this.camposConfig || []).map(String).filter((id) => mapeados.has(id));
        const atual = this.ordemCampos.filter((id) => mapeados.has(id));
        const configNaOrdemAtual = atual.filter((id) => config.includes(id));
        const configDiverge = config.some((id, i) => configNaOrdemAtual[i] !== id);

        const base = configDiverge ? [...config, ...atual] : atual;
        const ordem = [...new Set([...base, ...idsMapeados])];
        if (ordem.length !== this.ordemCampos.length || ordem.some((id, i) => id !== this.ordemCampos[i])) {
          this.ordemCampos = ordem;
        }
      },
      ordenarPrioridades() {
        const selecionados = new Set(this.prioridades.map(String));
        const naOrdem = this.ordemCampos.filter((id) => selecionados.has(id));
        const foraDaOrdem = [...selecionados].filter((id) => !this.ordemCampos.includes(id));
        const todos = [...naOrdem, ...foraDaOrdem];
        this.prioridades = [...todos.filter((id) => this.isBlindado(id)), ...todos.filter((id) => !this.isBlindado(id))];
      },
      alterarTipoOrdenacao(relevancia) {
        this.tipoOrdenacao = relevancia ? 'RELEVANCIA' : 'PADRAO';
        this.onPrioridadeChange();
      },
      isBlindado(campoId) {
        return this.blindados.includes(String(campoId));
      },
      estadoPrioridade(campoId) {
        const id = String(campoId);
        if (!this.prioridades.includes(id)) return 'NAO_SELECIONADO';
        return this.isBlindado(id) ? 'BLINDADO' : 'SELECIONADO';
      },
      iconeEstado(campoId) {
        return {
          NAO_SELECIONADO: 'mdi-checkbox-blank-outline',
          SELECIONADO: 'mdi-checkbox-marked',
          BLINDADO: 'mdi-lock'
        }[this.estadoPrioridade(campoId)];
      },
      corEstado(campoId) {
        return this.estadoPrioridade(campoId) === 'NAO_SELECIONADO' ? 'grey' : 'primary';
      },
      
      ciclarEstadoCampo(atributo) {
        if (this.loading) return;
        const id = String(atributo.id);
        const toastOpts = { position: 'topRight', timeout: 3000 };

        const atual = this.estadoPrioridade(id);
        if (atual === 'BLINDADO' && this.prioridades.length === 1) {
          this.$toast.warning('Mantenha ao menos um campo selecionado na prioridade.', '', toastOpts);
          return;
        }

        if (atual === 'NAO_SELECIONADO') {
          this.prioridades = [...this.prioridades, id];
          this.$toast.info(`Campo <b>${atributo.nome}</b> selecionado.`, '', toastOpts);
        } else if (atual === 'SELECIONADO') {
          this.blindados = [...this.blindados, id];
          this.$toast.success(`Campo <b>${atributo.nome}</b> blindado: estará presente em todas as rodadas.`, '', toastOpts);
        } else {
          this.blindados = this.blindados.filter((b) => b !== id);
          this.prioridades = this.prioridades.filter((p) => p !== id);
          this.$toast.info(`Campo <b>${atributo.nome}</b> desmarcado.`, '', toastOpts);
        }

        this.ordenarPrioridades();

        this.onPrioridadeChange();
      },
      rotuloRodada(idx) {
        const n = this.pageIndex * RODADAS_POR_PAGINA + idx + 1;
        return `${n}ª`;
      },
      onMover(evt) {
        if (evt.oldIndex === evt.newIndex) return;
        this.$emit('mover', { de: evt.oldIndex, para: evt.newIndex });
      },
      onCamposChange(rodada) {
        const campos = [...(rodada.campos || [])].map(String);
        this.$emit('editar-campos', {
          chave: rodada.chave,
          campos,
          estadoPorCampo: this.montarEstadoPorCampo(campos)
        });
      },
      adicionarRodadaFinal(rodada) {
        if (this.loading) return;
        const campos = this.garantirBlindados(rodada.campos);
        this.$emit('adicionar', {
          campos,
          estadoPorCampo: this.montarEstadoPorCampo(campos),
          tipoOrdenacao: rodada.tipoOrdenacao || null
        });
      },
      duplicarRodada(idx) {
        if (this.loading || idx < 0 || idx >= this.rodadas.length) return;
        this.$emit('duplicar', { chave: this.rodadas[idx].chave });
      },
      removerRodada(idx) {
        if (this.loading || this.totalRodadas <= 1) return;
        this.$emit('remover', { chave: this.rodadas[idx].chave });
      },
      prepararCampos(campos) {
        const comBlindados = this.garantirBlindados(campos);
        return { campos: comBlindados, estadoPorCampo: this.montarEstadoPorCampo(comBlindados) };
      },
      payloadPrioridade() {
        return {
          campos: [...this.prioridades],
          estadoPorCampo: this.montarEstadoPorCampo(),
          tipoOrdenacao: this.tipoOrdenacaoEfetivo
        };
      },
      chaveConfig({ campos, estadoPorCampo, tipoOrdenacao }) {
        const estado = Object.keys(estadoPorCampo || {})
          .sort()
          .map((id) => [id, estadoPorCampo[id]]);
        return JSON.stringify([campos, estado, tipoOrdenacao]);
      },
      registrarConfigBase() {
        this.$nextTick(() => {
          this.chaveConfigBase = this.chaveConfig(this.payloadPrioridade());
        });
      },
      onPrioridadeChange() {
        if (this.skipPrioridadeEmit) return;
        if (this.prioridadeDebounce) clearTimeout(this.prioridadeDebounce);
        this.prioridadeDebounce = setTimeout(() => {
          this.prioridadeDebounce = null;
          const payload = this.payloadPrioridade();
          const chave = this.chaveConfig(payload);
          if (chave === this.chaveConfigBase) return;
          this.chaveConfigBase = chave;
          this.$emit('prioridade-change', payload);
        }, 2000);
      },
      montarEstadoPorCampo(campos = this.prioridades) {
        const estado = {};
        (campos || []).map(String).forEach((id) => {
          if (this.isBlindado(id)) estado[id] = 'BLINDADO';
        });
        return estado;
      },
      getGeracaoPayload() {
        if (this.prioridades.length) {
          const campos = [...this.prioridades];
          return {
            campos,
            estadoPorCampo: this.montarEstadoPorCampo(campos),
            tipoOrdenacao: this.tipoOrdenacaoEfetivo,
            limit: RODADAS_BUFFER_INICIAL
          };
        }

        const campos = (this.atributos || []).slice(0, this.defaultPrioridades).map((a) => String(a.id));
        const estadoPorCampo = {};
        if (this.idCampoTuc) {
          if (!campos.includes(this.idCampoTuc)) {
            if (campos.length >= this.defaultPrioridades) campos[campos.length - 1] = this.idCampoTuc;
            else campos.push(this.idCampoTuc);
          }
          estadoPorCampo[this.idCampoTuc] = 'BLINDADO';
        }
        const tipoOrdenacao = Object.keys(estadoPorCampo).length ? 'RELEVANCIA' : this.tipoOrdenacao;
        return { campos, estadoPorCampo, tipoOrdenacao, limit: RODADAS_BUFFER_INICIAL };
      },
      validate() {
        if (!this.atributos.length) {
          return 'Não há campos mapeados para montar as rodadas.';
        }
        if (!this.rodadas.length) {
          return 'Carregue as rodadas antes de salvar.';
        }
        for (let i = 0; i < this.rodadas.length; i++) {
          const r = this.rodadas[i];
          if (!r.campos || !r.campos.length) {
            return `Selecione ao menos um campo na ${this.rotuloRodada(i)} rodada.`;
          }
        }
        return true;
      },
      getPayload() {
        return { rodadas: this.rodadas.map((r) => ({ chave: r.chave, campos: [...(r.campos || [])] })) };
      }
    }
  };
</script>

<style scoped>
  .rodada-card {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 12px 16px 8px;
    background: #fafafa;
  }

  .rodada-card__header {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eeeeee;
  }

  .rodada-drag-handle {
    cursor: grab;
  }

  .rodada-drag-handle:active {
    cursor: grabbing;
  }

  .campo-prioridade {
    display: flex;
    align-items: center;
    min-height: 28px;
    cursor: pointer;
    user-select: none;
    word-break: break-word;
  }

  .campos-prioridade-lista {
    display: flex;
    flex-wrap: wrap;
  }

  .campo-prioridade-item {
    display: flex;
    align-items: center;
    width: 33.333%;
    padding-right: 8px;
  }

  @media (max-width: 959px) {
    .campo-prioridade-item {
      width: 50%;
    }
  }

  @media (max-width: 599px) {
    .campo-prioridade-item {
      width: 100%;
    }
  }

  .campo-prioridade-drag {
    cursor: grab;
  }

  .switch-tipo-ordenacao >>> .v-input--switch__thumb {
    color: #e5502c !important;
  }

  .campo-prioridade--travado {
    cursor: not-allowed;
    opacity: 0.7;
  }

  .atributo-item {
    display: flex;
    align-items: flex-start;
    min-height: 28px;
    padding-right: 8px;
    word-break: break-word;
  }

  .atributo-item >>> .checkbox-conciliacao {
    margin-top: 3px;
    flex-shrink: 0;
  }

  .atributo-item >>> label {
    display: inline;
    line-height: 1.35;
    margin-left: 8px !important;
  }
</style>
